import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Activity, LayoutDashboard, Phone, Settings, Webhook } from 'lucide-react';
import { COMMUNICATIONS_TABS } from '../../models/MasterAdmin/communications';
import {
  commDesktopNavClass,
  commMobileNavWrapClass,
  commNavItemClass,
  commSidebarClass,
} from './communicationsUi';

const TAB_ICONS: Record<string, React.ReactNode> = {
  dashboard: <LayoutDashboard className="h-4 w-4 shrink-0" />,
  activity: <Activity className="h-4 w-4 shrink-0" />,
  calls: <Phone className="h-4 w-4 shrink-0" />,
  webhooks: <Webhook className="h-4 w-4 shrink-0" />,
  settings: <Settings className="h-4 w-4 shrink-0" />,
};

function isTabActive(pathname: string, tab: (typeof COMMUNICATIONS_TABS)[number]): boolean {
  if (tab.id === 'dashboard') {
    return pathname === tab.path || pathname === `${tab.path}/`;
  }
  return pathname === tab.path;
}

const CommunicationsSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <aside className={commSidebarClass}>
      <div className="border-b border-gray-200/80 px-3 py-3 dark:border-gray-800 sm:px-4 sm:py-4">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300">
            <Phone className="h-4 w-4" />
          </div>
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-gray-900 dark:text-white">Exotel Calling</p>
            <p className="hidden text-xs text-gray-500 dark:text-gray-400 sm:block">Voice calls, IVR & webhooks</p>
          </div>
        </div>
      </div>

      <nav className={commMobileNavWrapClass} aria-label="Exotel Calling tabs">
        {COMMUNICATIONS_TABS.map((tab) => {
          const active = isTabActive(location.pathname, tab);
          return (
            <NavLink key={tab.id} to={tab.path} className={commNavItemClass(active)}>
              {TAB_ICONS[tab.id]}
              <span className="whitespace-nowrap">{tab.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <nav className={commDesktopNavClass} aria-label="Exotel Calling navigation">
        {COMMUNICATIONS_TABS.map((tab) => {
          const active = isTabActive(location.pathname, tab);
          return (
            <NavLink key={tab.id} to={tab.path} className={commNavItemClass(active)}>
              {TAB_ICONS[tab.id]}
              <span>{tab.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default CommunicationsSidebar;
